import Flag from "@components/Flag";
import type { ComponentPropsWithoutRef, ElementType } from "react";

import type { MarketConfiguration } from "@/config/markets/const";
import { cn } from "@/lib/utils";

type MarketSelectorOptionProps<T extends ElementType> = {
  as?: T;
  market: MarketConfiguration;
};

export default function MarketSelectorOption<T extends ElementType>(
  props: MarketSelectorOptionProps<T> &
    Omit<ComponentPropsWithoutRef<T>, keyof MarketSelectorOptionProps<T>>,
) {
  const { as, market, className, ...rest } = props;
  const Component = as || "li";

  return (
    <Component
      className={cn(
        "flex cursor-pointer items-center space-x-2 p-3",
        className,
      )}
      key={market.code}
      {...rest}
    >
      <Flag
        code={market.code}
        className="h-4 w-4 shrink-0 rounded-full border border-black object-cover"
      />
      <span className="flex-1">
        <b>{market.label}</b>&nbsp;({market.language?.label})
      </span>
      <span className="shrink-0 text-gray-400 uppercase">
        {market.currency}
      </span>
    </Component>
  );
}
